// extracted by mini-css-extract-plugin
export default {"swiperSlide":"PhotosSection_swiperSlide__O1lwC","swiperWrapper":"PhotosSection_swiperWrapper__EA3it"};